// Constants
import { ERROR_GENERIC } from '../utils/constants/constants';
const baseUrl = `https://${process.env.REACT_APP_API}/api`;

/**
 * @interface Request
 * Describes the properties for request headers
 * @property {string} method Method
 * @property {string} endpoint Endpoint
 * @property {string} body JSON String (Optional)
 */
interface Request {
    method: string;
    headers: Headers;
    body?: string;
}

/**
 * @function apiFetch
 * Fetches from the game API
 *
 * @return {Promise}
 */
export const apiFetch = (
    method: string,
    endpoint: string,
    body: string = '',
) => {
    let request: Request = {
        method: method,
        headers: new Headers({
            Authorization: `Bearer ${localStorage.getItem('apiToken')}`,
            ['Content-Type']: 'application/json',
        }),
    };

    if (['PATCH', 'POST', 'PUT'].includes(method) === true) {
        request.body = body;
    }

    return new Promise<any>((resolve, reject) =>
        fetch(`${baseUrl}${endpoint}`, request)
            .then((response) => response.json())
            .then((result) => {
                if (
                    (result.code !== undefined && result.code !== 200) ||
                    result.message !== undefined
                ) {
                    reject(result.message);
                }

                if (result.error !== undefined && result.error === 'error') {
                    reject(result.data.message);
                }

                resolve(result);
            })
            .catch((error) => {
                console.error(error);
                reject(ERROR_GENERIC);
            }),
    );
};
